<!--
Author: TangChen
Date: 2019-10-23
Desc: 开户须知
 -->
<template>
    <div :class="'view-open-info view bg-white ' + className">
        <comp-title :title="title" />
        <div class="open-info">
            <div class="tit bt-white main">
                开户须知
            </div>
            <div class="info">
                <p class="name grey">
                    尊敬的用户：
                </p>
                <p class="waring grey">
                    您好！请准备好以下加盖企业公章的电子版开户材料： <span class="main">（上传文件单个大小不超过1.5m，总大小不超过36m，支持jpg，jpeg，png，pdf等格式）</span>
                </p>
                <p class="info-list">
                    一、账户业务申请表（经办人签章、加盖公章、法人章），请下载使用表单
                    <a v-if="fileInfo.bustype1" class="like-a" :href="$util.src('/common/download', { id: fileInfo.bustype1})">《账户业务申请表》</a>
                    <span v-else class="warning">&nbsp;暂未配置，联系基金公司客服处理</span>
                </p>
                <p class="info-list">
                    二、授权委托书（加盖公章、法人章），请下载使用表单
                    <a v-if="fileInfo.bustype2" class="like-a" :href="$util.src('/common/download', { id: fileInfo.bustype2})">《授权委托书》</a>
                    <span v-else class="warning">&nbsp;暂未配置，联系基金公司客服处理</span>
                </p>
                <p class="info-list">
                    三、企业法人营业执照（加盖公章）<span class="like-a" v-on:mouseenter.prevent="name='yingyezhizhao.jpeg'" v-on:mouseleave="name=''">查看示例</span>
                </p>
                <p class="info-list">
                    四、法定代表人证件（二代身份证需要正反面复印件，加盖公章）
                    <span class="like-a" v-on:mouseenter.prevent="name='sfz.png'" v-on:mouseleave="name=''">查看示例</span>
                </p>
                <p class="info-list">
                    五、经办人证件（二代身份证需要正反面复印件，加盖公章）
                    <span class="like-a" v-on:mouseenter.prevent="name='sfz.png'" v-on:mouseleave="name=''">查看示例</span>
                </p>
                <p class="info-list">
                    六、银行账户证明（加盖公章），请下载使用表单
                    <a v-if="fileInfo.bustype3" class="like-a" :href="$util.src('/common/download', { id: fileInfo.bustype3})">《银行账户证明》</a>
                    <span v-else class="warning">&nbsp;暂未配置，联系基金公司客服处理</span>
                </p>
                <p class="info-list">
                    七、控制人、受益人信息（加盖公章），请下载使用表单
                    <a v-if="fileInfo.bustype4" class="like-a" :href="$util.src('/common/download', { id: fileInfo.bustype4})">《受益人信息》</a>
                    <span v-else class="warning">&nbsp;暂未配置，联系基金公司客服处理</span>
                </p>
                <p class="info-list">
                    八、网上交易协议（加盖公章），请下载使用
                    <a v-if="fileInfo.bustype5" class="like-a" :href="$util.src('/common/download', { id: fileInfo.bustype5})">《网上交易协议》</a>
                    <span v-else class="warning">&nbsp;暂未配置，联系基金公司客服处理</span>
                </p>
                <div v-if="name!==''" class="example" :class="name==='sfz.png'?'sfz':''">
                    <img :src="require('../../assets/img/'+name)" />
                </div>
            </div>
            <div class="btn">
                <el-button type="yellow" class="medium" v-on:click.prevent="$router.push({name:'agentinfo'})">
                    我已准备好上述材料，立即开户
                </el-button>
                <el-button type="back" class="medium" v-on:click.prevent="$router.back()">
                    返回
                </el-button>
            </div>
        </div>
        <!--内容-->
    </div>
</template>

<script>
import mixin from "@/assets/js/mixin";
export default {
    name: "OpenInfo",
    mixins: [mixin],
    data () {
        return {
            name: "",
            fileInfo: {}
        };
    },
    mounted() {
        this.getFile();
    },
    methods: {
        getFile(){
            const that = this;
            this.$util.request("umpf/website/business/file",{bustype: "1,2,3,4,5",status: "3",filetype: "2"}).then(res=>{
                if(res.data){
                    let _x = {};
                    for(let i in res.data){
                        _x["bustype" + res.data[i].bustype] = res.data[i].file_id;
                    }
                    that.fileInfo = _x;
                }
            });
        }
    }
};
</script>
<style lang="scss">
    .view-open-info {
        margin-top: 5px;
        .open-info{
            padding: 10px 82px;
            .tit{text-align: center;font-size: 28px;padding: 30px 0;}
            .info{line-height: 34px;padding: 15px 0;position: relative;}
            .info-list{padding: 9px 0;width: 65%;line-height: 24px;}
            .btn{text-align: center;padding: 40px 0;}
            .example{
                width: 32%;position:absolute;top:100px;right:0px;img{width: 80%;height: 365px;}
                &.sfz{
                    img{height: 244px;}
                }
            }
        }
        /*颜色，背景写在css/theme.scss内views style下*/
    }
</style>
